import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { updateTaxCode, UpdateTaxCodePayload } from "@/api"
import { SchemaResponse } from "@/modules/types/common/schema"

const useUpdateTaxCode = (
  options: UseMutationOptions<SchemaResponse<null>, Error, UpdateTaxCodePayload> = {}
) => {
  return useMutation<SchemaResponse<null>, Error, UpdateTaxCodePayload>({
    mutationFn: async (data: UpdateTaxCodePayload) => {
      const response = await updateTaxCode(data)
      return response.data
    },
    ...options
  })
}

export default useUpdateTaxCode
